<template>
  <div class="d-flex">
    <book-new-dialog />
    <v-btn v-show="selected.length" small color="error" class="mr-2" depressed @click="onRemove">
      <v-icon left>delete</v-icon>Xóa
    </v-btn>
  </div>
</template>
<script>
import BookNewDialog from '@/modules/book/BookNewDialog.vue'
export default {
  components: {
    BookNewDialog
  },
  props: {
    selected: { type: Array, default: () => [] },
    options: Object,
    add: Boolean,
    remove: Boolean
  },
  methods: {
    onRemove () {
      this.$dialog.confirm({
        title: 'Xóa Cơ Sở Vật Chất Này',
        text: ` Bạn có Chắc Chắn xóa những đồ đã chọn ?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          this.$emit('remove', this.selected)
        }
      })
    },
    onConfirm () {
      this.$dialog.confirm({
        title: 'Xác Nhận Điểm Danh',
        text: ` Xác nhận buổi học đã diễn ra như dự kiến ?`,
        okText: 'Đúng Vậy',
        cancelText: 'Hủy',
        done: async () => {
          this.$emit(
            'update',
            this.selected.map(i => ({ ...i, state: 'confirmed' }))
          )
        }
      })
    },
    onReject () {
      this.$dialog.confirm({
        title: 'Xác Nhận Điểm Danh',
        text: ` Xác nhận buổi học đã KHÔNG diễn ra như dự kiến ?`,
        okText: 'Đúng Vậy',
        cancelText: 'Hủy',
        done: async () => {
          this.$emit(
            'update',
            this.selected.map(i => ({ ...i, state: 'rejected' }))
          )
        }
      })
    },
    onPay () {
      this.$dialog.confirm({
        title: 'Xác Nhận Trả Lương',
        text: ` Xác nhận đã trả lương trong trường họp trả lương bằng tiền mặt, hoặc trong trường hợp hệ thống không thể tự đánh dấu ngày công này là đã trả lương. Bạn Có chắc chắn muốn đánh dấu Đã Trả Lương ?`,
        okText: 'Xác Nhận',
        cancelText: 'Hủy',
        done: async () => {
          this.$emit(
            'update',
            this.selected.map(i => ({ ...i, state: 'paid' }))
          )
        }
      })
    }
  }
}
</script>
